<div class="row">
  <div class="form-group col-sm-6">
    <label for="testoLibero">Cerca (testo libero)</label>
    <div class="input-group" autofocus>
      <input class="form-control" required placeholder="Es. Nome e Cognome, grado, tipo di pratica"   type="text"
        id="testoLibero" name="testoLibero" [(ngModel)]="searchText"
        (keyup.enter)="search()">

      <span class="input-group-btn">
        <button class="btn btn-primary" type="button" (click)="search()" style="font-size: 15px;line-height: 1.4;">
          <span style="margin-left: -2px;" class="glyphicon glyphicon-search"></span>
          Cerca
        </button>
      </span>
    </div>
  </div>
</div>
<div class="row mb-10">
  <div class="col-sm-12">
    <button class="btn btn-primary right" type="button" (click)="selectAction(actions.CREA_PRATICA)"><span
        style="margin-left: -2px;" class="glyphicon glyphicon-plus"></span> Crea pratica</button>
  </div>
</div>
<app-suggested-practices
  [pratiche]="pratiche"
  [buttonAssociaHide] = "buttonAssociaHide"
  (createFascicoloEvent)="createFascicolo(actions.CREA_FASCICOLO, $event)"
  (associaFascicoloEvent)="associaFascicolo(actions.ASSOCIA, $event)">
</app-suggested-practices>
<div *ngIf="pratiche.length == 0">
  <p>Non ci sono pratiche suggerite per l'elaborazione </p>
</div>
